<template>
  <div class="row">
    <div class="col-12 col-lg-2 flex-column d-flex">
      <label class="mb-0 color-gray-6 text-small">Estatus:</label>
      <span class="d-flex align-items-center">
        <div class="status-indicator" :style="{ backgroundColor: item.color }">
          &nbsp;
        </div>
        <span class="text font-weight-bold">{{ item.text }}</span>
      </span>
    </div>
    <div class="col-12 col-lg-2 flex-column d-flex mt-2 mt-md-0">
      <label class="mb-0 color-gray-6 text-small">Usuario:</label>
      <span class="text font-weight-bold">
        {{ item.username }}
      </span>
    </div>
    <div class="col-12 col-lg-2 flex-column d-flex mt-2 mt-md-0">
      <label class="mb-0 color-gray-6 text-small">Número de PO:</label>
      <span class="text font-weight-bold">
        {{ item.poNumber | empty }}
      </span>
    </div>
    <div class="col-12 col-lg-2 flex-column d-flex mt-2 mt-md-0">
      <label class="mb-0 color-gray-6 text-small">Estatus de PO:</label>
      <span class="text font-weight-bold">
        {{ item.poStatus | empty }}
      </span>
    </div>
    <div class="col-12 col-lg-3 flex-column d-flex mt-2 mt-md-0">
      <label class="mb-0 color-gray-6 text-small">Suplidor:</label>
      <span class="text font-weight-bold">
        {{ item.supplier | empty }}
      </span>
    </div>
    <div class="col-12 mt-3 flex-column d-flex" v-if="item.comment">
      <label class="mb-0 color-gray-6 text-small">Comentario:</label>
      <span class="text font-weight-bold">{{ item.comment }}</span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'RecommendationStatusRow',
  components: {},
  data: () => ({}),
  props: {
    item: { type: Object, default: () => ({}) },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables/_colors.scss';
.title {
  font-size: 16px;
  font-weight: bold;
  color: map-get($colors, 'gray-12');
}
.event-date {
  font-weight: bold;
  font-size: 15px;
  color: #11291b;
  opacity: 1;
}
.status-indicator {
  width: 12px;
  height: 12px;
  float: left;
  border-radius: 50%;
  margin-right: 5px;
}
.text {
  font-size: 16px;
  color: #11291b;
}
.text-small {
  font-size: 14px;
}

.actionButton {
  border-radius: 19px;
}

.radius {
  padding: 7px 0 0 0 !important;
  width: 30px !important;
  height: 30px !important;
}
</style>
